import React from 'react';

function CartPage() {
  return (
    <div>
      <h1>Your Cart</h1>
      <p>Items you have added to your cart will appear here.</p>
    </div>
  );
}

export default CartPage;
